import { useCallback } from 'react';

import { useVideoStreamController_getBioscopeQuotaCheck } from '@/services/hooks';

import { mapQuotaCheckResponseToDomain } from './mappers';
import type { CheckQuotaRequest, UseCheckQuotaResult } from './types';

export function useCheckQuota(): UseCheckQuotaResult {
    const mutation = useVideoStreamController_getBioscopeQuotaCheck();

    const mutateAsync = useCallback(
        async (variables: CheckQuotaRequest) => {
            const response = await mutation.mutateAsync(variables);
            return mapQuotaCheckResponseToDomain(response.data);
        },
        [mutation.mutateAsync]
    );

    return {
        ...mutation,
        isLoading: mutation.isPending,
        mutateAsync,
        data: mutation.data ? mapQuotaCheckResponseToDomain(mutation.data.data) : undefined,
    };
}
